import { createFeatureSelector, createSelector } from '@ngrx/store';
import { ProjectState } from './projects.reducer';

export const selectProjectState = createFeatureSelector<ProjectState>('projects');

export const selectProjects = createSelector(selectProjectState, (state) => state.projects);

export const selectCurrentProject = createSelector(selectProjectState, (state) => state.currentProject);

export const selectProjectsLoading = createSelector(selectProjectState, (state) => state.loading);

export const selectProjectsCreating = createSelector(selectProjectState, (state) => state.creating);

export const selectProjectsUpdating = createSelector(selectProjectState, (state) => state.updating);

export const selectUpdatingProjectId = createSelector(selectProjectState, (state) => state.updatingProjectId);

export const selectProjectsDeleting = createSelector(selectProjectState, (state) => state.deleting);

export const selectDeletingProjectId = createSelector(selectProjectState, (state) => state.deletingProjectId);

export const selectProjectsError = createSelector(selectProjectState, (state) => state.error);

export const selectCampaigns = createSelector(selectProjectState, (state) => state.campaigns);

export const selectCampaignsLoading = createSelector(selectProjectState, (state) => state.loadingCampaigns || false);

// The reducer already enriches currentProject with campaign data in loadProjectCampaignsSuccess
export const selectCurrentProjectWithCampaigns = selectCurrentProject;

// Get project performance summary
export const selectCurrentProjectPerformance = createSelector(
    selectCurrentProjectWithCampaigns,
    (project) => project?.getPerformanceSummary() || null,
);

export const selectProjectById = (id: string | number) =>
    createSelector(selectProjects, (projects) => projects.find((project) => project.id === id) || null);

export const selectProjectsLoaded = createSelector(selectProjects, (projects) => projects.length > 0);
